import { action, observable } from "mobx";

import apiUrl from "@const/apiUrl";
import baseState from "../../baseState";
import { joinUrl } from "@utils/index";

export default class liveStreamState extends baseState {
    // 列表
    @observable list = {};
    @action
    setList = data => this.list = data;

    getList = data => this.fetch({ url: apiUrl.LIVE_STREAM.LIST, method: 'get', setState: "setList", data });

    // 详情
    @observable detail = {};
    @action
    setDetail = data => this.detail = data;

    getDetail = ({ id }) => this.fetch({ url: joinUrl(apiUrl.LIVE_STREAM.DETAIL, id), method: 'get', setState: "setDetail", data: { id } });

    // 创建
    insert = data => this.fetch({ url: apiUrl.LIVE_STREAM.CREATE, method: 'post', data });

    // 获取直播流地址
    @observable publishList = {};
    @action
    setPublishList = data => this.publishList = { records: data };
    // 推流 
    getPublishList = ({ id }) => this.fetch({ url: apiUrl.LIVE_STREAM.PUBLISH_URL.replace("{id}", id), method: 'get', setState: "setPublishList", data: { id } });

    @observable pullList = {};
    @action
    setPullList = data => this.pullList = { records: data };
    // 拉流 
    getPullList = ({ id }) => this.fetch({ url: apiUrl.LIVE_STREAM.PULL_URL.replace("{id}", id), method: 'get', setState: "setPullList", data: { id } });

    // 录制的开启和关闭
    switchOnOff = ({ isOnOff, id }) => this.fetch({ url: apiUrl.LIVE_STREAM.SWITCH_ON_OFF.replace("{id}", id).replace("{isOnOff}", isOnOff), method: 'post', data: { isOnOff, id } });

    // 推流历史
    @observable historyList = {};
    @action
    setHistoryList = data => this.historyList = data;
    getHistoryList = (data) => this.fetch({ url: apiUrl.LIVE_STREAM.HISTORY.replace("{id}", data.id), method: 'get', setState: "setHistoryList", data });


    // 录制视频
    @observable dvrList = {};
    @action
    setDvrList = data => this.dvrList = data;
    getDvrList = (data) => this.fetch({ url: apiUrl.LIVE_STREAM.DVR_LIST.replace("{id}", data.id), method: 'get', setState: "setDvrList", data });

    // 转发相关
    @observable forwardList = {};
    @action
    setForwardList = data => this.forwardList = data;
    getForwardList = (data) => this.fetch({ url: apiUrl.LIVE_STREAM.FORWARD_LIST, method: 'get', setState: "setForwardList", data });
    // 详情
    @observable forwardDetail = {};
    @action
    setForwardDetail = data => this.forwardDetail = data;
    getForwardDetail = ({ id }) => this.fetch({ url: apiUrl.LIVE_STREAM.FORWARD_DETAIL.replace("{id}", id), setState: "setForwardDetail", method: 'get', data: { id } });
    // 转发的开启和关闭
    switchForwardOnOff = ({ isOnOff, forwardId }) => this.fetch({ url: apiUrl.LIVE_STREAM.FORWARD_SWITCH.replace("{forwardId}", forwardId).replace("{isOnOff}", isOnOff), method: 'post', data: { isOnOff, forwardId } });
    // 转发的创建
    createForward = ({ streamId, forwardUrl, name}) => this.fetch({ url: apiUrl.LIVE_STREAM.FORWARD_SAVE, method: 'post', data: { streamId, forwardUrl, name} });
    // 转发的删除
    delForward = (id) => this.fetch({ url: apiUrl.LIVE_STREAM.FORWARD_DEL.replace("{id}", id), method: 'post', data: { id } });
    // 删除录音
    delDvr = (id) => this.fetch({ url: apiUrl.LIVE_STREAM.DVR_DELETE.replace("{dvrId}", id), method: 'post', data: { id } });
}
